export const hydrateTimelineConfig = config => {
  return {
    type: 'HYDRATE_TIMELINE_CONFIG',
    payload: config,
  };
};
